import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";  // Ajout de useLocation
import logoImage from "../../assets/img/logo-clem.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();  // Obtenir l'emplacement actuel
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  // Fonction pour vérifier si un lien est actif
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-gray-800 text-white p-2 shadow-md shadow-black/40 relative z-10 border-b border-gray-700/50">
      <div className="container mx-auto flex justify-between sm:justify-center items-center sm:gap-8">
        {/* Bouton menu mobile */}
        <button 
          className="sm:hidden text-white p-2" 
          onClick={toggleMenu}
          aria-label="Menu principal"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-12 w-12" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M4 6h16M4 12h16M4 18h16" 
            />
          </svg>
        </button>

        {/* Logo */}
        <img
          src={logoImage}
          alt="Logo Clément Rioche"
          className="h-16 w-auto sm:hover:scale-150 sm:transition-transform sm:duration-500 
                    sm:cursor-pointer transition-transform duration-200"
        />

        {/* Menu navigation desktop */}
        <nav className="hidden sm:block rounded-lg px-5 py-2 shadow-lg shadow-blue-500/20 bg-gray-700/50 backdrop-blur-sm">
          <ul className="flex space-x-6">
            <li>
              <Link
                to="/"
                className={`transition-colors duration-300 py-2 px-3 ${
                  isActive('/') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
              >
                Accueil
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={`transition-colors duration-300 py-2 px-3 ${
                  isActive('/projects') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
              >
                Projets
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={`transition-colors duration-300 py-2 px-3 ${
                  isActive('/services') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`transition-colors duration-300 py-2 px-3 ${
                  isActive('/contact') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Menu mobile déroulant */}
      <div
        className={`
          fixed top-0 left-0 h-72 w-64 bg-gray-800 shadow-lg transform transition-transform duration-500 ease-in-out z-20 rounded-lg
          ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}
          sm:hidden
        `}
      >
        <div className="flex justify-end p-4">
          <button 
            onClick={() => setIsMenuOpen(false)}
            className="text-white"
            aria-label="Fermer le menu"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        </div>
        <nav className="py-2">
          <ul className="flex flex-col space-y-4 px-6">
            <li>
              <Link
                to="/"
                className={`block transition-colors duration-300 py-2 px-3 border-b border-gray-700 ${
                  isActive('/') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={`block transition-colors duration-300 py-2 px-3 border-b border-gray-700 ${
                  isActive('/projects') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Projets
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={`block transition-colors duration-300 py-2 px-3 border-b border-gray-700 ${
                  isActive('/services') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`block transition-colors duration-300 py-2 px-3 border-b border-gray-700 ${
                  isActive('/contact') ? 'text-blue-300' : 'hover:text-blue-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Overlay pour fermer le menu en cliquant à l'extérieur */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-10 sm:hidden"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;
